import { NotificationType as AppNotificationType } from '@/features/notifications/notification-service-extension-shared/constants/app'
import NotificationGuard from '@/features/notifications/notification-service-extension-shared/guards/firebase'
import {
    NewOrderNotification as AppNewOrderNotification,
    Notification as AppNotification,
    PostponedOrderNotification as AppPostponedOrderNotification,
} from '@/features/notifications/notification-service-extension-shared/types/app'
import {
    NewOrderNotification as FirebaseNewOrderNotification,
    Notification as FirebaseNotification,
    PostponedOrderNotification as FirebasePostponedOrderNotification,
} from '@/features/notifications/notification-service-extension-shared/types/firebase'
import {
    convertChannelToApp,
    convertDeliveryTypeCategoryToApp,
} from '@/features/orders/utils/conversions'

export const transformAwaitingAcceptanceOrderNotification = (
    notification: FirebaseNewOrderNotification
): AppNewOrderNotification => ({
    id: notification.uuid,
    createdAt: notification.createdAt,
    type: AppNotificationType.AwaitingAcceptanceOrder,
    orderId: notification.orderUuid,
    orderChannel: convertChannelToApp(notification.orderChannel),
    orderCustomerName: notification.orderCustomerName,
    orderDeliveryTypeCategory: convertDeliveryTypeCategoryToApp(
        notification.orderDeliveryTypeCategory
    ),
    orderShortCode: notification.orderShortCode,
})

export const transformAcceptedOrderNotification = (
    notification: FirebaseNewOrderNotification
): AppNewOrderNotification => ({
    id: notification.uuid,
    createdAt: notification.createdAt,
    type: AppNotificationType.AcceptedOrder,
    orderId: notification.orderUuid,
    orderChannel: convertChannelToApp(notification.orderChannel),
    orderCustomerName: notification.orderCustomerName,
    orderDeliveryTypeCategory: convertDeliveryTypeCategoryToApp(
        notification.orderDeliveryTypeCategory
    ),
    orderShortCode: notification.orderShortCode,
})

export const transformPostponedOrderNotification = (
    notification: FirebasePostponedOrderNotification
): AppPostponedOrderNotification => ({
    id: notification.uuid,
    createdAt: notification.createdAt,
    type: AppNotificationType.PostponedOrder,
    orderId: notification.orderUuid,
    orderShortCode: notification.orderShortCode,
})

export const transformNotification = (
    notification: FirebaseNotification
): AppNotification | undefined => {
    if (NotificationGuard.isAwaitingAcceptanceOrder(notification)) {
        return transformAwaitingAcceptanceOrderNotification(notification)
    }

    if (NotificationGuard.isAcceptedOrder(notification)) {
        return transformAcceptedOrderNotification(notification)
    }

    if (NotificationGuard.isPostponedOrder(notification)) {
        return transformPostponedOrderNotification(notification)
    }
}
